import { useEffect, useState } from 'react';

const useCountdown = (deadline: Date | null) => {
  const [timeLeft, setTimeLeft] = useState(deadline ? deadline.getTime() - Date.now() : null);

  useEffect(() => {
    if (!deadline || deadline.getTime() - Date.now() < 0) {
      return;
    }

    const id = setInterval(() => {
      setTimeLeft(deadline.getTime() - Date.now());
    }, 1000);

    return () => {
      clearInterval(id);
    };
  }, [deadline]);

  return timeLeft;
};

export default useCountdown;
